import { ValidationErrorResponse } from "../../../services/ValidationError";

export interface FormValue {
    wasTouched: boolean,
    isValid: boolean | undefined
}

export interface TextFormValue extends FormValue {
    value: string
}

export interface NumberFormValue extends FormValue {
    value: number | undefined
}

export interface FormState {
    nombre: TextFormValue,
    descripcion: TextFormValue,
    precioNoche: TextFormValue,
    horaSalida: TextFormValue,
    minimoNoches: TextFormValue,
    maximoNoches: TextFormValue,
}

export const initialFormState: FormState = {
    nombre: { value: "", wasTouched: false, isValid: undefined },
    descripcion: { value: "", wasTouched: false, isValid: undefined },
    precioNoche: { value: "0", wasTouched: false, isValid: undefined },
    horaSalida: { value: "11", wasTouched: true, isValid: undefined },
    minimoNoches: { value: "", wasTouched: false, isValid: undefined },
    maximoNoches: { value: "", wasTouched: false, isValid: undefined },
}

export const resetValidStates = (formState: FormState) => {
    Object.keys(formState).forEach(_key => {
        const currentVal: FormValue = (formState as any)[_key] as FormValue;
        (formState as any)[_key] = { ...currentVal, isValid: undefined };
    });
}

export const invalidateStates = (formState: FormState, validationErrorResponse: ValidationErrorResponse) => {
    Object.keys(validationErrorResponse).forEach(errKey => {
        const errKeyStr = errKey as string;
        const currentVal: FormValue = (formState as any)[errKeyStr] as FormValue;
        (formState as any)[errKeyStr] = { ...currentVal, isValid: false };
    })
}